import { render, staticRenderFns } from "./SupplierAction.vue?vue&type=template&id=f484fd28&"
import script from "./SupplierAction.vue?vue&type=script&lang=js&"
export * from "./SupplierAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports